import React, { useEffect, useState } from "react";
import { getEvents } from "../Service/Api";
import { Link } from 'react-router-dom';  
import LazyLoad from 'react-lazyload';
const Events = () => {
  const [eventData, seteventData] = useState([]);
  const [openModel, setOpenmodal] = useState(false); 
  const [selectedItem, setSelectedItem] = useState(null); 
useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getEvents();  
        const filteredData = data.filter(event => event.date && !isNaN(new Date(event.date).getTime()));

        // Sort the filtered data in descending order by date
        filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));
        const latest10Events = filteredData.slice(0, 10);
        
        seteventData(latest10Events);
        
      } catch (error) {
        console.error("Failed to fetch news:", error);
        seteventData([]); // Set to empty to ensure the empty state is handled
      }
    };
    fetchData();
  }, []);

  const modalPopup = (item) => {
    setSelectedItem(item); // Set the clicked item's data
    setOpenmodal(true); // Open the modal
};

const handleClose = () => {
    setOpenmodal(false);
    setSelectedItem(null); // Clear the selected item
};
  const emptyArray = [
      { title: "No Data Available ", description: "No Data Available " } 
  ];
 
  return (
    <>
    <div className="newsbg eventbg">
    <div className='mainstitle'>  
        <h2>Events </h2> 
    <Link to="/SchoolEvents"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/arrow.png" className="img-fluid"/></Link> 
    </div>
    <marquee onMouseOver={(event) => event.currentTarget.stop()} direction="up" onMouseOut={(event) => event.currentTarget.start()}>
      <ul className="newsboxlist">
      {eventData.length > 0 ? eventData.map((item, index) => (   
         <li key={index}>
            <div className="newsbox">
              <div className="newsdesc"> 
                 <p onClick={() => modalPopup(item)}> {item.title}</p> 
              </div> 
              {item.attachments && item.attachments[0] && ( 
                <Link to={`https://webapi.entab.info/api/image/${item.attachments[0]}`} target="_blank"><i className="bi bi-paperclip"></i></Link> 
              )} 
              
            </div>
          </li>
          )) : 
      emptyArray.map((data) => (
         <li>
            <div className="newsbox">
              <div className="newsdesc"> 
              <p> </p>
              </div>
       
            </div>
          </li>
          ))
        }
      </ul>
    </marquee>
  </div>
  {openModel && selectedItem && (
    <div className="eventPopup">
      <div className="eventpopupbody">
        <div className="eventpopupcontent">
          <button onClick={handleClose} className="closebtn">X</button>
          <div className="schooleventbox">
          <div className="schooleventrightbox">
          <h5><div dangerouslySetInnerHTML={{ __html: selectedItem.title }} /> </h5>
              <p> <div dangerouslySetInnerHTML={{ __html: selectedItem.description }} /></p>
              {selectedItem.attachments && selectedItem.attachments[0] && ( 
                <div className="attachment popupattch">
                <Link to={`https://webapi.entab.info/api/image/${selectedItem?.attachments}`} target="_blank"> Click Here To View</Link>
            </div>
              )} 
          </div>
          {selectedItem.images && selectedItem.images.length > 0  && selectedItem.images.length === 1 ? (
            selectedItem.images.map((image, index) => (
              <div key={index} className="schooleventleftbox galleryCount sub-gallerycount">
                <LazyLoad>
                  <a
                    data-magnify="gallery"
                    data-src={`https://webapi.entab.info/api/image/${image}`} // Using image source for gallery
                    data-group="a"
                    href={`https://webapi.entab.info/api/image/${image}`}
                  >
                    <img
                      src={`https://webapi.entab.info/api/image/${image}`}
                      className="img-fluid float-start"
                      alt={`Image ${index + 1} of The Air Force School Subroto Park`} // Dynamic alt text
                    />
                  </a>
                </LazyLoad>
              </div>
            ))
          ) : null}
          {selectedItem.images && selectedItem.images.length > 0  && selectedItem.images.length > 1 ? (
            selectedItem.images.map((image, index) => (
              <div key={index} className="schooleventleftbox galleryCount sub-gallerycount  multi-img">
                <LazyLoad>
                  <a
                    data-magnify="gallery"
                    data-src={`https://webapi.entab.info/api/image/${image}`} // Using image source for gallery
                    data-group="a"
                    href={`https://webapi.entab.info/api/image/${image}`}
                  >
                    <img
                      src={`https://webapi.entab.info/api/image/${image}`}
                      className="img-fluid"
                      alt={`Image ${index + 1} of The Air Force School Subroto Park`} // Dynamic alt text
                    />
                  </a>
                </LazyLoad>
              </div>
            ))
          ) : null}
           
          </div>
          
           <div className="row">
           {selectedItem.galleryAttachments?.length > 0 && (
                selectedItem.galleryAttachments.map((item,index) => (
                  <div
                  key={index}
                  className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"
                >
                  <LazyLoad>
                  <a data-magnify="gallery" data-src="" data-group="a" href={`https://webapi.entab.info/api/image/${item}`}><img src={`https://webapi.entab.info/api/image/${item}`} className=" img-fluid" alt="The Air Force School Subroto Park" /></a>
                    </LazyLoad>
                </div> 
                ))
      )}
           </div>
        </div>
      </div>
    </div>
  )}
    </>
  );
};

export default Events;
